import React from 'react'

function AppointmentPage() {
  return (
    <div>Page RDV</div>
  )
}

export default AppointmentPage